import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IContentType } from "./routeType";

const { key, getPath } = getApi("types.content.getAll");

type IExtractedRouteType = IContentType["contentTypeCollectionRetrieve"];

export type IGetContentType = IPickCollectionQuery<IExtractedRouteType>;

const getContentType: Fetcher<
  IGetContentType["response"],
  IGetContentType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetContentType = createQuery({
  queryKey: [key],
  fetcher: getContentType,
});
